import { defineStore } from 'pinia';
import { _e } from '../helpers/l10n';


export const useCepStore = defineStore('cep', {
  state: () => ({
    cidades: [],
    estados: _e('cep_estados'),
  }),
  actions: {
    async loadCidades(estado_id) {
      if(estado_id) {
        const body = new FormData();
        body.append('estado', estado_id);

        const req = await fetch(_e('cep_url'),{
          method: 'POST',
          body
        });

        const json = await req.json();
        this.cidades = json;
      } else {
        this.cidades = [];
      }
    },
    nomeEstado(estado_id) {
      const estado = this.estados.find(estado => estado.id == estado_id);
      return estado ? estado.text : '';
    },
    nomeCidade(cidade_id) {
      const cidade = this.cidades.find(cidade => cidade.id == cidade_id);
      return cidade ? cidade.text : '';
    }
  }
});
